import { Badge } from "design-system/atoms/Badge"

export function IssueOccurrenceCountBadge({ count }: { count: number }) {
  return (
    <Badge variant="outline" className="tabular-nums">
      {count}
    </Badge>
  )
}
